<template>
    <ValidationObserver tag="form" ref="observer" @submit.prevent="submit()">
        <FormInput :label="etiquetaAbonado" :name="nombreCampoAbonado" type="number" v-model="numeroAbonado" rules="required" />
        <FormInput :label="etiquetaPin" :name="etiquetaPin" type="number" v-model="localData.pin" rules="required|max:4|min:4" />
        <div class="alert alert-danger d-flex align-items-center justify-content-between mt-3 p-1" v-if="error">
            <div class="pl-2">
                <b v-if="error === 'The given data was invalid.'">{{ $t('perfil.datos_no_validos') }}</b>
                <b v-else>{{ error.message }}</b>
            </div>
        </div>

        <div class="row">
            <div class="col-12 d-flex justify-content-between">
                <button type="submit" class="button" name="button" :disabled="loading">{{ $t('formularios.enviar') }}</button>
            </div>
        </div>
    </ValidationObserver>
</template>

<script>
    import { TEATRO_HASH_CD_ELDENSE, TEATRO_HASH_SDPONFERRADINA, TEATRO_HASH_RACING_FERROL } from '@/constants/teatros';
    export default {
        props: ['error', 'loading', 'data'],
        computed: {
            esEldense() {
                return this.$store.getters.getTeatro?.hash === TEATRO_HASH_CD_ELDENSE;
            },
            esFerrol() {
                return this.$store.getters.getTeatro?.hash === TEATRO_HASH_RACING_FERROL;
            },
            // Racing de Ferrol pide el número de abonado de la temporada anterior y
            // lo manda como `n_abonado`.
            numeroAbonado: {
                get() {
                    return this.esFerrol ? this.localData.n_abonado : this.localData.id_persona;
                },
                set(valor) {
                    if (this.esFerrol) {
                        this.localData.n_abonado = valor;
                    } else {
                        this.localData.id_persona = valor;
                    }
                }
            },
            nombreCampoAbonado() {
                return this.esFerrol ? 'ID' : this.etiquetaAbonado;
            },
            // Eldense identifica al abonado por su número, no por un ID genérico.
            etiquetaAbonado() {
                if (this.esFerrol) {
                    return this.$t('formularios.id_simple');
                }

                if (this.esEldense) {
                    return this.$t('formularios.n_abonado', { abonado: this.$store.getters.getTeatro?.texto_abonado });
                }

                // SD Ponferradina rotula el identificador con la temporada de la lista
                // de abonados activa (el nombre de la lista ya es "2025/2026").
                if (this.$store.getters.getTeatro?.hash === TEATRO_HASH_SDPONFERRADINA) {
                    return this.etiquetaAbonadoTemporada;
                }

                return this.$t('formularios.id');
            },
            etiquetaAbonadoTemporada() {
                const abonado = this.$store.getters.getTeatro?.texto_abonado;
                const temporada = this.$store.getters.getListaAbonados?.nombre;

                return temporada
                    ? this.$t('formularios.n_abonado_temporada', { abonado, temporada })
                    : this.$t('formularios.n_abonado', { abonado });
            },
            etiquetaPin() {
                return this.esEldense ? this.$t('partidos.lfp_4_cifras') : this.$t('formularios.pin');
            }
        },
        data() {
            return {
                localData: {
                    id_persona: this.data.id_persona || '',
                    n_abonado: this.data.n_abonado || '',
                    pin: this.data.pin || ''
                }
            }
        },
        methods: {
            async submit() {
                const isValid = await this.$refs.observer.validate();
                if (isValid) {
                    this.buscarAbono();
                }
            },
            buscarAbono() {
                // El resto de teatros LFP busca por `id_persona`; Ferrol, por `n_abonado`.
                const datos = this.esFerrol
                    ? { n_abonado: this.localData.n_abonado, pin: this.localData.pin }
                    : this.localData;

                this.$emit('buscarAbonado', datos);
            }
        }
    }
</script>